'use client';

import { getDatadogRumInitConfiguration } from '@/components/datadog-rum-config';
import { datadogRum } from '@datadog/browser-rum-slim';
import { useEffect } from 'react';

import type { PropsWithChildren } from 'react';

let initialized = false;

const DatadogRumProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    if (initialized) return;

    const config = getDatadogRumInitConfiguration();
    if (!config) return;

    initialized = true;
    datadogRum.init(config);
  }, []);

  return children;
};

export default DatadogRumProvider;
